import { DialogTitle, DialogContent, DialogContentText, Typography, CircularProgress, TextField, DialogActions, Button, Dialog } from '@mui/material'
import { useFlag } from '@unleash/proxy-client-react'
import { capitalize } from 'lodash'
import { ChangeEvent } from 'react'

interface EnterEmailDialogProps {
  email: string
  error: string
  loading: boolean
  open: boolean
  providerName: string
  attemptEmailChange: () => Promise<void>
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void
  handleClose: () => void
}

export default function EnterEmailDialog({
  attemptEmailChange,
  email,
  error,
  loading,
  open,
  handleChange,
  handleClose,
  providerName
}: EnterEmailDialogProps) {
  const isFirebaseSsoEnabled = useFlag('isFirebaseSsoEnabled')

  if (isFirebaseSsoEnabled) {
    return null
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Enter your email</DialogTitle>
      <DialogContent>
        <DialogContentText>Enter your email to continue signing in with your {capitalize(providerName)} account.</DialogContentText>
        {loading && (
          <Typography textAlign="center">
            <CircularProgress />
          </Typography>
        )}
        {!loading && (
          <TextField
            id="enterEmail"
            name="enterEmail"
            autoFocus
            error={Boolean(error)}
            helperText={error}
            margin="dense"
            label="Email Address"
            type="email"
            fullWidth
            variant="standard"
            value={email}
            onChange={handleChange}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={attemptEmailChange}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  )
}
